/**
 * True when the user has asked their OS for reduced motion.
 *
 * **Call this at the moment the motion is about to start, not once at mount.**
 * The setting can be toggled while the app is open, and a value captured at
 * mount time keeps whatever it read for the lifetime of whatever captured it —
 * so a component mounted before the toggle goes on animating afterwards.
 *
 * Reading the media query is cheap (no listener, no subscription, no re-render),
 * which is what makes the just-in-time read the simple option rather than the
 * expensive one.
 *
 * Guards `window` and `matchMedia` so it is safe under server rendering and in
 * test environments that provide only part of the DOM.
 */
export function prefersReducedMotion(): boolean {
  return (
    typeof window !== "undefined" &&
    typeof window.matchMedia === "function" &&
    window.matchMedia("(prefers-reduced-motion: reduce)").matches
  );
}
